import { render, staticRenderFns } from "./ProjectTimelineItem.vue?vue&type=template&id=5bd321bc&"
import script from "./ProjectTimelineItem.vue?vue&type=script&lang=js&"
export * from "./ProjectTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VTimelineItem})
